import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [getSensorConfigInfoDeviceList 그룹 > 장비목록 리스트를 출력한다.]
   * @author {Yang}
   * @param  {[ConfigParamVO]} params [managegroupId...]
   * @return {[type]}        [description]
   */
  getSensorConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-sensor-config-info-device-list.do`, params);
  },
  /**
   * [exportSensorConfigInfoDeviceList 그룹 > 장비목록 리스트를 엑셀 출력한다.] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author {Yang -> NaJY}
   * @param  {[Integer]} managegroupId [managegroupId]
   * @return {[type]}               [description]
   */
  exportSensorConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/export-sensor-config-info-device-list.do`, params);
  },

  /**
   * 노드> 요청 Parameter 정보
   * @author hyo
   * @param
   * @return
   */
  getSensorObjInfoParams(params) {
    return axios.post(`${baseUrl}/config/get-sensor-obj-info-params.do`, params);
  },

  /**
   * 노드>구성현황 기본정보
   * @author hyo
   * @param
   * @return
   */
  getSensorConfigInfoBasic(params) {
    return axios.post(`${baseUrl}/config/get-sensor-config-info-basicstatus.do`, params);
  },

  /**
   * 노드>구성현황 RTU OBJ
   * @author hyo
   * @param
   * @return
   */
  getRtuDeviceInfo(params) {
    return axios.post(`${baseUrl}/config/get-sensor-config-rtu-device.do`, params);
  },
  // /**
  //  * 노드>구성현황
  //  * @author hyo
  //  * @param
  //  * @return
  //  */
  // getFmsList(params) {
  //   return axios.get(`${baseUrl}/config/get-fms-list.do`, {params});
  // },
  //
  /**
   * 노드>구성현황 수집방식
   * @author hyo
   * @param
   * @return
   */
  getRscGetmethods(params) {
    return axios.post(`${baseUrl}/config/get-fms-rsc-getmethods.do`, params);
  },

  /**
   * 노드>구성현황 SQL일 시 데이터소스
   * @author hyo
   * @param
   * @return
   */
  getRuleRscGetmethodSources(params) {
    return axios.get(`${baseUrl}/config/get-fms-rule-rsc-getmethod-sources.do`, { params });
  },

  /**
   * 노드 > 구성현황 수정
   * @author hyo
   * @param
   * @return
   */
  updateSensorConfigInfo(params) {
    return axios.post(`${baseUrl}/config/update-sensor-obj-config.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/sensor/sensor-info.js